// @ts-ignore
import { createI18n } from 'vue-i18n'

import locales from '@/localization/locales/locales.json'

// Returns client set locale otherwise defaults to 'fr'
function getLocale() {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
        return localStorage.getItem("locale") ?? 'fr'
    }
    return 'fr'
}

let localeData = locales

// Check if the specific key exists and modify only its value
if (localeData.fr.g_txt_sav_email) {
    localeData.fr.g_txt_sav_email = localeData.fr.g_txt_sav_email.replace(/@/g, "{'@'}");
}

if (localeData.fr.w_txt_footer_media_link_youtube) {
    localeData.fr.w_txt_footer_media_link_youtube = localeData.fr.w_txt_footer_media_link_youtube.replace(/@/g, "{'@'}");
}

if (localeData.fr.w_txt_footer_contact_social_links_yt_url) {
    localeData.fr.w_txt_footer_contact_social_links_yt_url = localeData.fr.w_txt_footer_contact_social_links_yt_url.replace(/@/g, "{'@'}");
}

// Create VueI18n instance with options
const i18n = createI18n({
    locale: getLocale(),
    messages: locales,
    fallbackLocale: 'fr',
    legacy: false, // you must set `false`, to use Composition API
})

export default i18n